import { rgba } from 'polished';
import colors from './colors';

export default {
  header: '0 4px 8px #0000000f',
  cookieBar: `1px 7px 15px ${rgba(colors.gray[900], 0.1)}`,
};
